import React from 'react';
import { useChatStore } from '../stores/chat-store';

interface ChatBubbleProps {
  hasNotification?: boolean;
  showLabel?: boolean;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ hasNotification, showLabel }) => {
  const { toggleChat } = useChatStore();

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-2">
      {showLabel && (
        <span className="bg-surface text-text-muted text-xs font-medium px-3 py-1.5 rounded-full shadow-md border border-border">
          Support
        </span>
      )}
      <button
        onClick={toggleChat}
        aria-label="Open support chat"
        className="w-14 h-14 rounded-full bg-primary text-white shadow-lg hover:bg-primary-dark transition-colors flex items-center justify-center"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        {hasNotification && (
          <span
            data-testid="chat-notification-badge"
            className="absolute top-0 right-0 w-3 h-3 bg-error rounded-full border-2 border-white"
          />
        )}
      </button>
    </div>
  );
};

export default ChatBubble;
